import type { CSSProperties } from "react";

export const statusStyles: Record<string, CSSProperties> = {
  eligible: { background: "#dcfce7", color: "#16a34a" },
  "under review": { background: "#fef9c3", color: "#ca8a04" },
  under_review: { background: "#fef9c3", color: "#ca8a04" },
  disputed: { background: "#fee2e2", color: "#dc2626" },
  held: { background: "#dbeafe", color: "#2563eb" },
  paid: { background: "#dcfce7", color: "#16a34a" },
};

/** Normalize API status keys for style lookup (e.g. under_review → under review). */
export const normalizeStatusKey = (status: string = ""): string =>
  status.trim().toLowerCase().replace(/[_-]+/g, " ");

/** Format status for display (e.g. pending_payment → Pending Payment). */
export const formatStatusLabel = (status: string = ""): string => {
  const raw = status.trim().toLowerCase();
  const labelOverrides: Record<string, string> = {
    paid_pending_confirmation: "Confirming payment",
    failed_unavailable: "Refund in progress",
    pending_payment: "Pending Payment",
    timeout_unconfirmed: "Timeout Unconfirmed",
    "customer-accepted": "Confirmed",
    "awaiting-inspection": "Awaiting Inspection",
  };

  if (labelOverrides[raw]) return labelOverrides[raw];

  const normalized = normalizeStatusKey(status);
  if (!normalized) return "";

  return normalized
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/** @deprecated Prefer formatStatusLabel */
export const formatCautionFeeStatus = formatStatusLabel;

export const getCautionFeeStatusStyle = (
  status: string = "",
): CSSProperties => {
  const normalized = normalizeStatusKey(status);
  const raw = status.trim().toLowerCase();

  return (
    statusStyles[normalized] ??
    statusStyles[raw] ?? {
      background: "#f0f0f0",
      color: "#555",
      border: "none",
    }
  );
};

export const rentStatusMessages: Record<string, string> = {
  pending_payment: "Complete your payment to secure this property.",
  paid_pending_confirmation: "We’ve received your proof of payment and are confirming it. This usually takes a few hours.",
  failed_unavailable: "Your payment was received, but this property was let to someone else moments before. We’re refunding you in full. Our team will contact you.",
  completed: "This tenancy has ended.",
  cancelled: "This booking was cancelled or expired before payment was completed. Please start a new booking.",
};
